export default __webpack_public_path__ + "static/media/disabled_vessel.d74af9c2.png";